/**
 * Created by lilya on 19.10.2014.
 */

function CharsetMatch(conf, csName, lang) {
  this.confidence = conf;
  this.charsetName = csName;
  this.lang = lang;
}

module.exports = CharsetMatch;


//////////////////
// WEBPACK FOOTER
// ./node_modules/charset-detector/src/charset-match.js
// module id = 13
// module chunks = 0